import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { AlertsState } from '../alerts-state';
import * as fromAlerts from './alerts.reducer';

export function getReducers(): ActionReducerMap<AlertsState> {
  return {
    dismissals: fromAlerts.reducer,
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<AlertsState>> = new InjectionToken<ActionReducerMap<AlertsState>>(
  'AlertsReducers'
);

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
